__turbopack_context__.v({
  "badge": "index-module__13lBSG__badge",
  "card": "index-module__13lBSG__card",
  "change": "index-module__13lBSG__change",
  "check": "index-module__13lBSG__check",
  "isLoading": "index-module__13lBSG__isLoading",
  "loadingDots": "index-module__13lBSG__loadingDots",
  "location": "index-module__13lBSG__location",
  "metaLine": "index-module__13lBSG__metaLine",
  "pincodeForm": "index-module__13lBSG__pincodeForm",
  "pincodeInput": "index-module__13lBSG__pincodeInput",
  "resultPill": "index-module__13lBSG__resultPill",
  "sddDotPulse": "index-module__13lBSG__sddDotPulse",
  "sddShimmerSweep": "index-module__13lBSG__sddShimmerSweep",
  "shimmerTitle": "index-module__13lBSG__shimmerTitle",
  "slot": "index-module__13lBSG__slot",
  "timelineLabel": "index-module__13lBSG__timelineLabel",
  "timerDigits": "index-module__13lBSG__timerDigits",
  "title": "index-module__13lBSG__title",
  "titleRow": "index-module__13lBSG__titleRow",
  "zapBox": "index-module__13lBSG__zapBox",
  "zapLayer": "index-module__13lBSG__zapLayer",
});
